import React, { Component } from 'react';
import lowerFirst from 'lodash/lowerFirst';
import classNames from 'classnames';

import DetailsModal from '../../global/DetailsModal';
import Asset from '../../global/Asset';
import { getModifierOptionBackground } from '../../../../../utils/Utils';

class ListModifier extends Component {
  sortModifierOptionsByGroup() {
    const {
      modifier: {
        options = [],
      },
    } = this.props;
    const groups = {};

    options.forEach((option) => {
      let { groupName } = option;
      groupName = groupName || 'main';
      groups[groupName] = Array.isArray(groups[groupName])
        ? [...groups[groupName], option]
        : [option];
    });

    return groups;
  }

  getActiveOption() {
    const {
      modifier: {
        activeStateProp,
        options = [],
      },
      selectedModifierOptions,
    } = this.props;

    return options.find(({ value, selected }) => (
      (activeStateProp && value === this.props[lowerFirst(activeStateProp)])
      || selectedModifierOptions?.find((selectedModifierOption) => selectedModifierOption.value === value)
      || selected
    ));
  }

  renderOptionsGroup(groups, slugLowerCase, activeOption = {}) {
    const {
      toggleModifierOptionAction,
      modifier,
      modifier: {
        type,
        modifierOperation,
      },
      withRedirect = true,
    } = this.props;

    return Object.entries(groups).map(([groupName, groupOptions]) => (
      <div key={groupName} className="pdp-options-group">
        {groupName !== 'main' && (
          <div className="pdp-options-group-name">{groupName}</div>
        )}
        <div className={classNames('pdp-options-ul', slugLowerCase)}>
          {groupOptions.map((option, j) => {
            const {
              label,
              value,
              description,
              selected,
              asset,
              colors,
              borderColor,
            } = option;
            return (
              <div
                style={{
                  ...(colors?.length > 0 && { background: getModifierOptionBackground(colors) }),
                  ...(borderColor && { border: `1px solid ${borderColor.hex}` }),
                }}
                role="button"
                key={j}
                aria-label={description}
                onClick={toggleModifierOptionAction.bind(
                  this,
                  {
                    modifier,
                    option,
                  },
                  withRedirect,
                )}
                className={classNames(value, `pdp-options-${slugLowerCase}`, {
                  active:
                    (activeOption.value === value)
                    || selected
                    || (!activeOption.value && value.toLowerCase() === 'none'),
                  'pdp-options-circle': modifierOperation === 'UpdateAddonItemVariant' || type === 'ColorPicker' || type === 'AddToCartModifier',
                  'pdp-options-icon': asset,
                  'pdp-options-size': slugLowerCase.includes('size'),
                  'has-border': !!borderColor,
                })}
              >
                {asset ? (
                  <Asset asset={asset} />
                ) : (
                  <span className="title">{label}</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    ));
  }

  render() {
    const {
      fetchProductDetailsAction,
      selectedModifierOptions,
      modifier: {
        className,
        slug,
        title,
        showModifierValue,
        subTitle,
        modals: [modal],
        requiredActiveModifierOptions,
      },
    } = this.props;

    const groups = this.sortModifierOptionsByGroup();
    const activeOption = this.getActiveOption();
    const slugLowerCase = slug?.toLowerCase() || '';
    let shouldRender = true;
    // If all the requiredActiveModifierOptions have been selected
    if (Array.isArray(requiredActiveModifierOptions) && requiredActiveModifierOptions.length) {
      shouldRender = requiredActiveModifierOptions?.every((requiredModifier) => (
        selectedModifierOptions.some((modifierOption) => (
          modifierOption.value === requiredModifier.value
        ))
      ));
    }

    return shouldRender && (
      <div className={classNames('pdp-options', slugLowerCase)}>
        <div className="pdp-options-header">
          <span className="pdp-options-header-title">{title}</span>
          {showModifierValue && (
            <span className="pdp-options-header-value">{activeOption?.description}</span>
          )}
        </div>
        {subTitle && <div className="pdp-options-description">{subTitle}</div>}
        <div className={classNames('pdp-options-wrapper', className)}>
          {this.renderOptionsGroup(groups, slugLowerCase, activeOption)}
          {modal && (
            <span className="pdp-details-info">
              <DetailsModal
                teaserCopy={modal.teaserCopy}
                teaserIcon={modal.teaserIcon}
                salesTiers={modal.salesTiers}
                popUpCopy={modal.copy}
                fetchProductDetails={fetchProductDetailsAction}
                header={modal.header}
                footnote={modal.footnote}
                asset={modal.assets && modal.assets[0]}
                links={modal.links}
              />
            </span>
          )}
        </div>
      </div>
    );
  }
}

export default ListModifier;
